import { jsx as _jsx } from "react/jsx-runtime";
// SPDX-License-Identifier: AGPL-3.0-or-later
import { useLanguage } from '../i18n/LanguageProvider.js';
import {} from '../i18n/dictionary.js';
/**
 * Renders the error/warning findings attached to a single field. Returns
 * `null` when there is nothing to show so the surrounding layout doesn't
 * reserve empty space. `role="alert"` + `aria-live="assertive"` so
 * findings appearing after submit are announced; `aria-atomic` keeps the
 * whole list spoken as one announcement instead of per-item churn.
 *
 * Translation: Finding.code drives a lookup into the chrome dictionary
 * (key `finding.<code>`). When the dictionary has no entry — typical
 * for project-specific validators we haven't translated yet — falls
 * back to the validator's English `message`. The validator stays
 * language-agnostic; this component owns the patient-facing copy.
 */
export function FormError({ findings, id }) {
    const { t, lang } = useLanguage();
    if (findings.length === 0)
        return null;
    return (_jsx("ul", { id: id, "data-form-error": "true", role: "alert", "aria-live": "assertive", "aria-atomic": "true", children: findings.map((f, i) => (_jsx("li", { "data-severity": f.severity, children: translatedMessage(f, t, lang) }, `${f.code}-${String(i)}`))) }));
}
function translatedMessage(f, t, _lang) {
    // Opt-in translation: only translate when the validator marked the
    // finding with an `i18nKey`. Findings without it carry custom
    // copy (e.g. the MagicLinkModal's hand-rolled "email or phone is
    // required" wording) — leave their `message` alone.
    if (f.i18nKey === undefined)
        return f.message;
    const args = (f.context ?? {});
    const translated = t(f.i18nKey, args);
    if (translated === f.i18nKey) {
        // Key didn't resolve in the dictionary — fall back to the
        // validator's English message. The dictionary's own missing-key
        // warning has already fired in dev.
        return f.message;
    }
    return translated;
}
//# sourceMappingURL=FormError.js.map